export default __webpack_public_path__ + "static/urbansitter-2-d898d2798ba2379dbc000f8d1eae9a3f.mp4";